import { createAction } from "redux-actions";
import { IAction } from "reduxsauce";
import { IPatchPayload } from "../../components/course-author/helpers/patches";
import { IFullCourse } from "../../components/course-author/types";
import { IOrganization } from "../../reducers/course-author/types";
import { mergeActionDefinitions } from "../../utils";

export const CourseAuthorActions = mergeActionDefinitions("CourseAuthor", {
  addImmersiveBackground: ["courseId", "course", "files", "link"],
  cloneCourse: ["course", "organizationId", "navAction"],
  createStyle: [],
  fetchAllOrganizations: [],
  fetchCourse: ["courseId"],
  fetchCourseChanges: ["course", "courseId", "count", "offset"],
  handleAddImmBgFailure: ["error"],
  handleAddImmBgSuccess: [],
  handleCloneCourseFailure: ["error"],
  handleCloneCourseSuccess: [],
  handleCreateStyleFailure: ["error"],
  handleCreateStyleSuccess: [],
  handleFetchAllOrganizationsFailure: ["error"],
  handleFetchAllOrganizationsSuccess: ["organizations"],
  handleFetchCourseChangesFailure: ["error"],
  handleFetchCourseChangesSuccess: ["courseChanges"],
  handleFetchCourseFailure: ["error"],
  handleFetchCourseSuccess: ["course", "autocompleteApi", "fileUploadApi", "localizedMessageApi"],
  handleFileUploadFailure: ["error"],
  handleFileUploadSuccess: [],
  handleMigrateContentToHtmlFailure: ["error"],
  handleMigrateContentToHtmlSuccess: ["course"],
  handlePatchCourseFailure: ["error"],
  handlePatchCoursePlayerFailure: ["error"],
  handlePatchCoursePlayerSuccess: [],
  handlePatchCourseSuccess: ["courseId"],
  handlePatchStyleFailure: ["error"],
  handlePatchStyleSuccess: [],
  handleResolveAuxiliaryFailure: ["error"],
  handleResolveAuxiliarySuccess: ["key", "value"],
  handleUpdateFullCourseFailure: ["error"],
  handleUpdateFullCourseSuccess: ["course", "admins", "changes", "editors"],
  migrateContentToHtml: [],
  mount: ["courseId"],
  patchCourse: ["patchPayload", "courseId"],
  patchCoursePlayer: ["courseId", "patchPayload"],
  patchStyle: ["styleId", "patchPayload"],
  resolveAuxiliaryData: ["requestName", "requestData"],
  simplePatchCourse: ["patchPayload", "courseId"],
  unmount: [],
  updateFullCourse: ["courseId"],
});

export interface IErrorAction extends IAction {
  error: Error;
}

export interface ICourseIdAction extends IAction {
  courseId: string;
}

export interface IStyleIdAction extends IAction {
  styleId: string;
}

export interface IPatchPayloadAction extends IAction {
  patchPayload: IPatchPayload;
}

export interface IAddImmersiveBgAction extends IAction {
  courseId: string;
  course: IFullCourse;
  styledId: string;
  files: FileList;
  link: string;
}

export interface ICloneCourseAction extends IAction {
  course: IFullCourse;
  organizationId: string;
}

export interface IRequestPreviewPayload {
  courseId: string;
}

export type Action =
  | "COURSE_AUTHOR/FETCH_ADMINISTRABLE_ORGS"
  | "COURSE_AUTHOR/HANDLE_FETCH_ADMINISTRABLE_ORGS_FAILURE"
  | "COURSE_AUTHOR/HANDLE_FETCH_ADMINISTRABLE_ORGS_SUCCESS"
  | "COURSE_AUTHOR/HANDLE_REQUEST_PREVIEW_COURSE_INST_SUCCESS"
  | "COURSE_AUTHOR/HANDLE_REQUEST_PREVIEW_COURSE_INST_FAILURE"
  | "COURSE_AUTHOR/REQUEST_PREVIEW_COURSE_INST"
  | "COURSE_AUTHOR/RESET_PREVIEW_COURSE_INST"
  | "COURSE_AUTHOR/ANDLE_FETCH_FULL_COURSE_SUCCESS"
  | "COURSE_AUTHOR/HIDE_LINEAR_PROGRESSION_WARNING";

export const HANDLE_REQUEST_PREVIEW_COURSE_INST_SUCCESS: Action =
  "COURSE_AUTHOR/HANDLE_REQUEST_PREVIEW_COURSE_INST_SUCCESS";
export const HANDLE_REQUEST_PREVIEW_COURSE_INST_FAILURE: Action =
  "COURSE_AUTHOR/HANDLE_REQUEST_PREVIEW_COURSE_INST_FAILURE";
export const REQUEST_PREVIEW_COURSE_INST: Action = "COURSE_AUTHOR/REQUEST_PREVIEW_COURSE_INST";
export const RESET_PREVIEW_COURSE_INST: Action = "COURSE_AUTHOR/RESET_PREVIEW_COURSE_INST";
export const FETCH_ADMINISTRABLE_ORGS: Action = "COURSE_AUTHOR/FETCH_ADMINISTRABLE_ORGS";
export const HANDLE_FETCH_ADMINISTRABLE_ORGS_FAILURE: Action = "COURSE_AUTHOR/HANDLE_FETCH_ADMINISTRABLE_ORGS_FAILURE";
export const HANDLE_FETCH_ADMINISTRABLE_ORGS_SUCCESS: Action = "COURSE_AUTHOR/HANDLE_FETCH_ADMINISTRABLE_ORGS_SUCCESS";
export const HIDE_LINEAR_PROGRESSION_WARNING: Action = "COURSE_AUTHOR/HIDE_LINEAR_PROGRESSION_WARNING";

export const HANDLE_FETCH_FULL_COURSE_SUCCESS: Action = "COURSE_AUTHOR/ANDLE_FETCH_FULL_COURSE_SUCCESS";

export const hideLPWarning = createAction<void>(HIDE_LINEAR_PROGRESSION_WARNING);
export const resetPreviewCourseInst = createAction<void>(RESET_PREVIEW_COURSE_INST);
export const requestPreviewCourseInst = createAction<IRequestPreviewPayload>(REQUEST_PREVIEW_COURSE_INST);
export const handleRequestPreviewCourseInstSuccess = createAction<string>(HANDLE_REQUEST_PREVIEW_COURSE_INST_SUCCESS);
export const handleRequestPreviewCourseInstFailure = createAction<{
  message: string;
}>(HANDLE_REQUEST_PREVIEW_COURSE_INST_FAILURE);
export const fetchAdministableOrgs = createAction<string[]>(FETCH_ADMINISTRABLE_ORGS);
export const handleAdministableOrgsSuccess = createAction<IOrganization[]>(HANDLE_FETCH_ADMINISTRABLE_ORGS_SUCCESS);
export const handleAdministableOrgsFailure = createAction<{
  message: string;
}>(HANDLE_FETCH_ADMINISTRABLE_ORGS_FAILURE);
export const handleFetchFullCourseSuccess = createAction<IFullCourse>(HANDLE_FETCH_FULL_COURSE_SUCCESS);
